export default __webpack_public_path__ + "static/media/icone Password.f25649ad.svg";